import * as Service from 'types/service';
import { StatusBar } from 'components/service/party/partyRedesignCard/StatusBar';
import { emotionPartyStatesSelector } from 'selectors/service/secondaryStatesSelector';
import { useSelector } from 'react-redux';

interface Props {
  primaryState: Service.PartyState;
  stateName: string;
  isEligibleForHoldCharge: boolean;
}

const PartyStatusBar: React.FC<Props> = ({ primaryState, stateName, isEligibleForHoldCharge }) => {
  const partyStates = useSelector(emotionPartyStatesSelector);

  // look for an exact match first:
  let barColor = partyStates.find(
    (partyState) => partyState.stateName === stateName && partyState.primaryState === primaryState
  )?.color;

  // however if we didn't find anything, let's just look for something that matches the primary state at least
  // even if the partyState.stateName is a mismatch.
  //
  // In particular we've noticed that the POS system at the French Laundry can mark a 'left' party as being
  // 'paid', even though the dashboard config notion of 'paid' status is that the primary state which goes along
  // with that is 'seated', not 'left'.
  barColor ??=
    partyStates.find((partyState) => partyState.primaryState === primaryState)?.color ??
    'var(--spec-grey)';

  if ((primaryState === 'NO_SHOW' || primaryState === 'CANCELED') && !isEligibleForHoldCharge) {
    barColor = 'var(--spec-grey)';
  }

  return <StatusBar barColor={barColor} />;
};

export default PartyStatusBar;
